export default function () {
  // Adds article ID to Local storage var
  const article = document.querySelector('article[data-article-id]');
  if (article) {
    const articleTrackerArray = JSON.parse(localStorage.getItem('PlacetelArticleTracker')) ? JSON.parse(localStorage.getItem('PlacetelArticleTracker')) : [];

    const articleId = article.getAttribute('data-article-id');
    if (!articleTrackerArray.includes(articleId)) {
      articleTrackerArray.push(articleId);
    }

    localStorage.setItem('PlacetelArticleTracker', JSON.stringify(articleTrackerArray));
  }

  // Checks completion status for articles in boxes
  const articleBox = document.querySelectorAll('.guide-hub-box');
  if (articleBox.length) {
    const articleTrackerArray = JSON.parse(localStorage.getItem('PlacetelArticleTracker')) ? JSON.parse(localStorage.getItem('PlacetelArticleTracker')) : [];

    articleBox.forEach(function(element) {
      let articleComplete = 0;
      let articles = element.querySelectorAll('.guide-hub-box-article');

      articles.forEach(function(article) {
        const articleId = article.getAttribute('data-article-id');
        if (articleTrackerArray.includes(articleId)) {
          articleComplete++;
        }
      });

      element.querySelector('.guide-hub-box-progress-complete').textContent = articleComplete.toString();
      element.querySelector('.guide-hub-box-progress-total').textContent = articles.length.toString();
      element.querySelector('.guide-hub-box-progress-bar-inner').style.width = articleComplete === 0 ? '0%' : articleComplete / articles.length * 100 + '%';
    });
  }
}
